import { z } from "zod";

/**
 * Teams app distribution modes
 * - everyone: All users in organization can install (default)
 * - specific_users: Only specified users can install
 * - specific_groups: Only members of specified groups can install
 * - mixed: Both specific users AND groups
 */
export const TEAMS_DISTRIBUTION_MODES = [
  "everyone",
  "specific_users",
  "specific_groups",
  "mixed"
] as const;
export const DistributionModeSchema = z.enum(TEAMS_DISTRIBUTION_MODES);
export type DistributionMode = z.infer<typeof DistributionModeSchema>;
